module.exports = __webpack_public_path__ + "static/media/ai-technology.0c9a5065.png";